import { Component } from '@angular/core';
import { GridCard } from '../../card/card.component';
import { GridViewBase } from '../grid-view-base.component';

@Component({
  selector: 'lepi-grid-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css'],
  standalone: true,
  imports: [GridCard],
})
export class GridGallery extends GridViewBase {}
